import { getPersistedState } from '../../persistedState';
import { YammerState } from '../../state/types';
import { getPersistKey } from '../persistConfig/selectors';

export const getEcsConfig = (state: YammerState) => state.ecsConfig;

export const getPersistedEcsConfig = async (key: string) => {
  const state = await getPersistedState(key);

  return state?.ecsConfig;
};

export const getEtagFromStateOrPersistedState = async (state: YammerState): Promise<string | undefined> => {
  const reduxEtag = getEcsConfig(state).etag;
  if (reduxEtag) {
    return reduxEtag;
  }

  const persistKey = getPersistKey(state);
  if (!persistKey) {
    return;
  }

  const persistedEcsConfig = await getPersistedEcsConfig(persistKey);

  return persistedEcsConfig?.etag;
};
